export const COMPANY = {
  companyName: "CARTENA Paweł Świeć",

  shortName: "CARTENA",

  accountNumber: "81 1030 0019 0109 8503 0021 5804",

  iban: "PL81103000190109850300215804",

  bank: "Bank Millennium",

  website: "https://cartena.pl",

  email: "kontakt@cartena.pl",
};